<template>
    <v-card>
        <v-toolbar flat dense color="blue-grey" dark>
            <v-toolbar-title>Dekklogg</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear indeterminate v-if="loading"/>
        <p v-else-if="log.length === 0" class="pa-3 text-center grey--text">Ingen logg funnet.</p>
        <v-list three-line v-else class="log-list">
            <template v-for="(item, index) in log">
                <div>
                    <v-divider v-if="index > 0"/>
                    <v-list-item :key="item.id">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ item.description }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <small class="d-block">
                                    {{ item.dateString }}
                                </small>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn icon title="Fjern fra logg" @click="removeFromLog(item)">
                                <v-icon color="red">delete</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </div>
            </template>
        </v-list>
    </v-card>
</template>
<script>
    import moment from 'moment';

    export default {
        name: 'change-log-list',
        props: [
            'customerId',
            'carId',
            'tireStorageId',
            'tireId'
        ],

        data() {
            return {
                loading: false,
                log: []
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.loading = true;

                let params = {
                    customer: this.customerId,
                    car: this.carId,
                    tireStorage: this.tireStorageId,
                    tire: this.tireId
                };

                this.$http.get('change-log', {params}).then(response => {
                    this.log = response.data.data.map(it => {
                        return {
                            ...it,
                            dateString: moment(it.created_at).format('ll')
                        }
                    });
                }).finally(() => this.loading = false);
            },

            removeFromLog(item) {
                let ok = confirm(`Vil du slette "${item.title}: ${item.description}" fra bilens logg?`);
                if (!ok) return;

                this.$http.delete(`change-log/${item.id}`).then(response => {
                    this.$root.addMessage('Loggdata fjernet.', 'green');
                    return this.loadData();
                }).finally(() => this.loading = false);
            }
        },
    }
</script>

<style scoped>
    .log-list {
        padding-top: 0;
        padding-bottom: 0;
        max-height: 500px;
        overflow-y: scroll;
    }
</style>
